export const messages = {
    "shared-link.footer.link.install": "Experimente o {brandName} gratuitamente",
    "shared-link.footer.link.mobile": "{brandName} para dispositivos móveis",
    "shared-link.footer.link.android": "Android",
    "shared-link.footer.link.ios": "iOS",
    "shared-link.password-dialog-box.title": "Dados protegidos",
    "shared-link.password-dialog-box.message": "Especifique a senha para acessar os dados compartilhados",
    "shared-link.password-dialog-box.hint.password": "Senha",
    "shared-link.password-dialog-box.message.invalid-password": "A senha está incorreta",
    "shared-link.form.button.open": "Abrir",
    "shared-link.page-not-found.title": "Página não encontrada",
    "shared-link.page-not-found.message.main": "A página que você está tentando acessar não foi encontrada.",
    "shared-link.page-not-found.message.description": "O link pode ter expirado ou você pode ter digitado o endereço incorretamente.",
    "shared-link.page-not-found.message.error": "Código de erro: 404",
    "shared-link.restore-file.label.size": "Tamanho",
    "shared-link.restore-file.button.restore": "Baixar",
    "shared-link.links-table.column.name": "Nome",
    "shared-link.links-table.column.size": "Tamanho",
    "shared-link.links-table.action.restore": "Baixar",
    "shared-link.links-table.action.restore-all": "Baixar tudo",
    "shared-link.side-bar.selected.title:plural": "{count} itens selecionados | {count} item selecionado | {count} itens selecionados",
    "shared-link.links-table.label.size": "Tamanho",
    "shared-link.links-table.message.empty-folder": "Esta pasta está vazia"
};
